import Api, { make, Response } from 'src/services/api'

import { Id } from 'src/types'

export async function getApprovalsPending(
  organization_id: Id,
  date_start: string,
  date_end: string
): Promise<Response<any>> {
  return make({
    axiosCall: Api.post(`organizations/${organization_id}/graph_pendings`, {
      data: { date_start, date_end }
    })
  })
}

export async function getCcChart(
  organization_id: Id,
  date_start: string,
  date_end: string
): Promise<Response<any>> {
  return make({
    axiosCall: Api.post(`organizations/${organization_id}/graph_cc`, {
      data: { date_start, date_end }
    })
  })
}

export async function getCostsChart(
  organization_id: Id,
  date_start: string,
  date_end: string
): Promise<Response<any>> {
  return make({
    axiosCall: Api.post(`organizations/${organization_id}/graph_costs`, {
      data: { date_start, date_end }
    })
  })
}

export async function getUserChart(
  organization_id: Id,
  date_start: string,
  date_end: string,
  amount: number
): Promise<Response<any>> {
  return make({
    axiosCall: Api.post(`organizations/${organization_id}/graph_user`, {
      data: { date_start, date_end, qtde_users: amount }
    })
  })
}

export async function getServiceChart(
  organization_id: Id,
  date_start: string,
  date_end: string
): Promise<Response<any>> {
  return make({
    axiosCall: Api.post(`organizations/${organization_id}/graph_service`, {
      data: { date_start, date_end }
    })
  })
}

export async function getTravelersChart(
  organization_id: Id,
  date_start: string,
  date_end: string
): Promise<Response<any>> {
  return make({
    axiosCall: Api.post(`organizations/${organization_id}/graph_travels`, {
      data: { date_start, date_end }
    })
  })
}
